import { NO_ACCOUNT } from "./crewApp/pages/inventorySearch/context";

const initState = {
  user: null,
  loading: false,
  reloadYard: null,
  lastSelectedAisle: {
    aisle: null,
    shipmentId: null,
  },
  theme: {},
  announcements: {
    showAnnouncements: false,
    fetchTimestamp: 0,
  },
  searchState: {
    searchTerm: "",
    selectedAccount: NO_ACCOUNT,
  },
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case "LOGIN":
      debugger;
      return {
        ...state,
        user: action.payload,
      };
    case "LOGOUT":
      debugger;
      return {
        ...state,
        user: null,
        reloadYard: null,
      };
    // case "SET_ANNOUNCEMENTS":
    //   return {
    //     ...state,
    //     announcements: {
    //       ...state.announcements,
    //       showAnnouncements: action.payload.showAnnouncements,
    //       fetchTimestamp: action.payload.fetchTimestamp
    //         ? action.payload.fetchTimestamp
    //         : state.announcements.fetchTimestamp,
    //       announcementList: action.payload.announcementList,
    //       isConfirmOpen: action.payload.isConfirmOpen ?? true,
    //     },
    //   };
    // case "SET_LAST_ANNOUNCEMENTS_CHECK_TIMESTAMP":
    //   return {
    //     ...state,
    //     announcements: { ...state.announcements },
    //   };
    // case "SET_IS_CONFIRM_OPEN":
    //   return {
    //     ...state,
    //     announcements: {
    //       ...state.announcements,
    //       isConfirmOpen: action.payload,
    //     },
    //   };
    case "SET_LOADING":
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    case "SET_SEARCH_TERM":
      return {
        ...state,
        searchState: {
          ...state.searchState,
          searchTerm: action.payload,
        },
      };
    case "SET_SELECTED_ACCOUNT":
      return {
        ...state,
        searchState: {
          ...state.searchState,
          selectedAccount: action.payload,
        },
      };
    case "CLEAR_SEARCH_STATE":
      return {
        ...state,
        searchState: {
          searchTerm: "",
          selectedAccount: NO_ACCOUNT,
          trackRedirect: false,
        },
      };
    case "SET_LAST_SELECTED_AISLE":
      return {
        ...state,
        lastSelectedAisle: action.payload || {
          aisle: null,
          shipmentId: null,
        },
      };
    default:
      break;
  }
  return state;
}
